module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "page-sidebar",
    attrs: {
      "data-pages": "sidebar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    staticClass: "open active m-t-30"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.courses2'
      }
    }
  }, [_vm._v("Courses")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.reports'
      }
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.setting'
      }
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lms.emaillogs'
      }
    }
  }, [_vm._v("Sent mails")]), _vm._v(" "), _vm._m(6)], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-header"
  }, [_c('img', {
    staticClass: "brand",
    attrs: {
      "src": "/static/img/logo-white.svg",
      "alt": "logo",
      "data-src": "/static/img/logo-white.svg",
      "data-src-retina": "/static/img/logo-white.svg",
      "width": "180"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar-header-controls"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("LMS")]), _vm._v(" "), _c('span', {
    staticClass: " open  arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-book-reader custom_reader"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-file-alt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "fas fa-cog"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon-thumbnail"
  }, [_c('i', {
    staticClass: "far fa-envelope"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ef441b0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/sidebar.vue
// module id = 1070
// module chunks = 27